<script>
  import { catalog, urlParams } from '../base/store'
  import { pagesShortlist } from '../base/utils'
  const SCOPE = 2
  let el
  $: ({ count, curr, last } = ($catalog.data || {}).pagination || {})
// Handler
  const setPage = i => async e => {
    if (i === 1) {
      urlParams.removeParam('page')
    } else {
      urlParams.setParam('page', i)
    }
    await urlParams.applyFilters()
    el.closest('section').scrollIntoView({
      behavior: "smooth"
    })
  }
</script>

<div class="pagination-div" bind:this={el}></div>

{#if last > 1}
  <button class="pagination-back"
    on:click={setPage(curr - 1)}
    disabled={curr === 1 || !curr}
  >
    <span class="pag-prev">
      <svg width="32" height="8" viewBox="0 0 32 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.646446 4.35356C0.451185 4.15829 0.451185 3.84171 0.646446 3.64645L3.82843 0.464469C4.02369 0.269206 4.34027 0.269206 4.53553 0.464468C4.7308 0.659731 4.7308 0.976313 4.53553 1.17158L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53554C4.34027 7.7308 4.02369 7.7308 3.82843 7.53554L0.646446 4.35356ZM32 4.5L1 4.5L1 3.5L32 3.5L32 4.5Z" fill="#252525"/>
        </svg>                  
    </span> 
  </button>
  <ul class="pagination__catalog-nums">
    {#each pagesShortlist(curr, last, SCOPE) as item}
      {#if item}
        {#if item === curr || !curr}
          <li class="catalog-num__item active">{item}</li>
        {:else}
          <li class="catalog-num__item" on:click={setPage(item)}>{item}</li>
        {/if}
      {:else}
        <li class="catalog-num__item dots">...</li>
      {/if}
    {/each}
  </ul>
  <button class="pagination-next"
    on:click={setPage(curr + 1)}
    disabled={curr === last}
  >
    <span class="pag-next">
      <svg width="32" height="8" viewBox="0 0 32 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M31.3536 4.35356C31.5488 4.15829 31.5488 3.84171 31.3536 3.64645L28.1716 0.464469C27.9763 0.269206 27.6597 0.269206 27.4645 0.464468C27.2692 0.659731 27.2692 0.976313 27.4645 1.17158L30.2929 4L27.4645 6.82843C27.2692 7.02369 27.2692 7.34027 27.4645 7.53554C27.6597 7.7308 27.9763 7.7308 28.1716 7.53554L31.3536 4.35356ZM-4.37114e-08 4.5L31 4.5L31 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z" fill="#252525"/>
        </svg>                  
    </span>
  </button>
{/if}
